/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import _getViewPort from '../../Utilities/get-view-port';
import { ID5MfrmSuggestionCardsViewProps } from './d5-mfrm-suggestion-cards';

export default (props: ID5MfrmSuggestionCardsViewProps) => {
    const styles = 'mfrm-suggestion-cards__';
    const {
        config: { heading , subHeading },
        suggestionCards
    } = props;

    let headingDisplay = null;
    if (heading && heading.text) {
        const HeadingTag = heading.tag ? (`${heading.tag}` as keyof JSX.IntrinsicElements) : 'h2';
        headingDisplay = (
            <div className='row'>
                <HeadingTag className={`${styles}heading`}>{heading.text}</HeadingTag>
            </div>
        );
    }

    let subHeadingDisplay = null;
    if (subHeading && subHeading.text) {
        const HeadingTag = subHeading.tag ? (`${subHeading.tag}` as keyof JSX.IntrinsicElements) : 'h3';
        subHeadingDisplay = (
            <div className='row'>
                <HeadingTag className={`${styles}subheading`}>{subHeading.text}</HeadingTag>
            </div>
        );
    }

    return (
        <div className='mfrm-suggestion-cards' data-cy='Suggestion-Cards'>
            {headingDisplay}
            {subHeadingDisplay}
            <div className={`${styles}container`}>
                    <div className={`${styles}content`}>{suggestionCards}</div>
            </div>
        </div>
    );
};
